import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  RemoveEstimateGrantMutation as RemoveEstimateGrantMutationResult,
  Scalars,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const RemoveEstimateGrantMutation = graphql(`
  mutation RemoveEstimateGrant($id: ID!) {
    removeEstimateGrant(id: $id) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
      }
    }
  }
`);

type Variables = { id: Scalars['ID']['input'] };

const useRemoveEstimateGrant = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    RemoveEstimateGrantMutationResult,
    Error,
    Variables
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<RemoveEstimateGrantMutationResult, Error, Variables>({
    mutationFn: ({ id }) =>
      gqlClient.request(RemoveEstimateGrantMutation, { id }),
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.removeEstimateGrant,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useRemoveEstimateGrant;
